import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'input[type=datetime-local][appEpochDatetimeLocal]',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EpochDatetimeLocalDirective),
            multi: true
        }],
    standalone: false
})
export class EpochDatetimeLocalDirective implements ControlValueAccessor {
  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};
  private disabled = false;

  constructor(private el: ElementRef<HTMLInputElement>, private r: Renderer2) {}

  // model -> view
  writeValue(epochSeconds: number | null): void {
    const el = this.el.nativeElement;
    if (epochSeconds && Number.isFinite(epochSeconds)) {
      const d = new Date(epochSeconds * 1000);
      const pad = (n: number) => String(n).padStart(2, '0');
      const v = `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
      this.r.setProperty(el, 'value', v);
    } else {
      this.r.setProperty(el, 'value', '');
    }
  }

  // view -> model
  @HostListener('input', ['$event.target.value'])
  _onInput(val: string) {
    if (!val) { this.onChange(null); return; }
    const t = new Date(val).getTime();
    this.onChange(Number.isFinite(t) ? Math.floor(t / 1000) : null);
  }

  @HostListener('blur') _onBlur() { this.onTouched(); }

  registerOnChange(fn: (value: number | null) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.r.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }
}
